import BaseController from "confinus_ui/base_controller";

export default class InputFinalDetailsConfirmationController extends BaseController {
  public static targets = ["checkbox", "submit"];

  declare private readonly submitTarget: HTMLButtonElement;
  declare private readonly checkboxTarget: HTMLInputElement;

  public handleConfirmationChanges() {
    this.submitTarget.disabled = !this.checkboxTarget.checked;
  }
}
